module.exports = __webpack_public_path__ + "static/parade-2019-house01-321057a4a020ec8782d2b66bfabdbce4.jpg";